(function() {
	'use strict';

	angular.module('crewHourReport').config(config);

	function config($stateProvider) {
		$stateProvider
				.state(
						'crewHourReport',
						{
							url : '/crew-hour-report',
							views : {
								'crewHourReportView' : {
									templateUrl : 'crew-hour-report/views/crew-hour-report.tpl.html',
									controller : 'CrewHourReportCtrl',
									controllerAs : 'crewHourReport'
								}
							}
						});
	}
}());
